import { ACDLRoute, BaseRouteConfig } from './BaseRoute';

export class FreeAccessPath extends BaseRouteConfig {
  public readonly Index = 'freeaccess';
  public readonly View = new ACDLRoute<{ workspaceId: string; projectId: string; imageId: string; filterId: string }>(
    `${this.Path}/:projectId/:imageId/:filterId`
  );
}
